import { combineReducers } from 'redux';
import activeUserReducer from './activeUserReducer';
import cartInfoReducer from './cartInfoReducer';

export default combineReducers({
    activeUser : activeUserReducer,
    cartInfo : cartInfoReducer,
})